import ModuleFourReflection from "../../../../src/components/forms/ModuleFourReflection";
import * as React from 'react';
export default {
  ModuleFourReflection,
  React
};